import { debounce } from 'lodash'

export const queryBase = {

    loadingKey: 'loading',
    error: debounce(function(error) {

        if(this.onQueryError){
            this.onQueryError(error)
        }

    }, 500)
};